import React from 'react';
import * as _ from 'lodash';
import { RuleTypeLabelPipe } from '../../../../shared/pipes/RuleTypeLabelPipe';
import { RiskFactoryPipe } from '../../../../shared/pipes/RiskFactorPipe';
import { humanize, RiskCategoryLabel } from '../simulation.model';

/* What a variant of a "Test this change" tries: the rules it changes, and the ratios of the risk factors it changes. */
export const RuleSetChanges = ({ changes }) => {
    const rules = _.get(changes, 'rules', []);
    const riskRatios = _.get(changes, 'riskRatios', {});

    if (_.isEmpty(rules) && _.isEmpty(riskRatios)) {
        return <span className={'sim-muted'}>No change to the rules.</span>;
    }

    return (
        <div className={'sim-rule-set-changes'}>
            {rules.map(rule => (
                <div key={rule.ruleType} style={{ marginBottom: 8 }}>
                    <strong>{RuleTypeLabelPipe(rule.ruleType)}</strong>
                    {_.isBoolean(rule.enabled) && (
                        <span className={'sim-tag'}>
                            {rule.enabled ? 'enabled' : 'disabled'}
                        </span>
                    )}
                    {_.map(rule.config, (value, key) => (
                        <span key={key} className={'sim-tag'}>
                            {humanize(key)}: {value}
                        </span>
                    ))}
                </div>
            ))}
            {_.map(riskRatios, (ratios, category) => (
                <div key={category} style={{ marginBottom: 8 }}>
                    <strong>
                        Risk ratios · {RiskCategoryLabel[category] || category}
                    </strong>
                    {_.map(ratios, (ratio, factor) => (
                        <span key={factor} className={'sim-tag'}>
                            {RiskFactoryPipe(factor)}: {ratio}
                        </span>
                    ))}
                </div>
            ))}
        </div>
    );
};
